export default class Menu {
	constructor() {
		const openButton = document.querySelector( '#xsmenu' );
		const closeButton = document.querySelector( '#xsclose' );
		const menu = document.querySelector( '#menu-main-menu' );

		openButton.addEventListener( 'click', () => {
			openButton.style.display = 'none';
			closeButton.style.display = 'block';
			menu.style.display = 'block';
		} );

		closeButton.addEventListener( 'click', () => {
			openButton.style.display = 'block';
			closeButton.style.display = 'none';
			menu.style.display = 'none';
		} );

		menu.querySelectorAll( '.menu-item' ).forEach( ( currentValue ) => {
			if ( currentValue.querySelector( 'a' ) ) {
				currentValue
					.querySelector( 'a' )
					.addEventListener( 'click', () => {
						if ( window.innerWidth <= 767 ) {
							menu.style.display = 'none';
							closeButton.style.display = 'none';
							openButton.style.display = 'block';
						}
					} );
			}
		} );

		window.addEventListener( 'resize', () => {
			closeButton.style.display = 'none';
			if ( window.innerWidth >= 1024 ) {
				openButton.style.display = 'none';
				menu.style.display = 'block';
			} else {
				openButton.style.display = 'block';
				menu.style.display = 'none';
			}
		} );
	}
}
